import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=f87087ce&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=f87087ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87087ce",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Settings.vue
// module id = null
// module chunks = 